import React, { useContext, useEffect, useState } from 'react';
import {
    getInstitutionsType,
    getLanguagesType,
    getInstitutionByTypeId,
    getInstitutionClasses,
    getStudentsByInstitutionId,
    updateStudent,
    deleteStudent,
    getAuthorizedPersonsProfile,
} from '../../../actions';
import { Context } from '../../../defaults';
import { TreeSelect, Row, Col, Select, Empty, Form, Input, Card, Descriptions, Popconfirm, Tooltip, Switch, message } from 'antd';
import { CarryOutTwoTone, DeleteTwoTone, EditTwoTone, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { groupBy } from '../../../utils';
import { emailRegex, loginRegex, phoneRegex, studyYearRegex, schoolYearRegex, userRole } from '../../../common';
import { MaskedInput } from 'antd-mask-input';
const { TreeNode } = TreeSelect;

export const StudentsTable2 = () => {
    const { dictionary, language, setLoading } = useContext(Context);
    const [institutionsType, setInstitutionsType] = useState();
    const [languagesType, setLanguagesType] = useState();
    const [classes, setClasses] = useState();
    const [students, setStudents] = useState();
    const [selectedInstitutionType, setSelectedInstitutionType] = useState();
    const [groupedInstitutions, setGroupedInstitutions] = useState({});
    const [groupedClasses, setGroupedClasses] = useState({});
    const [institutions, setInstitutions] = useState([])
    const [selectedInstitution, setSelectedInstitution] = useState();
    const [selectedStudent, setSelectedStudent] = useState();
    const [edit, setEdit] = useState(false);

    const filterInstitutionsByTypeId = (id) => {
        setSelectedStudent();
        setSelectedInstitution();
        if (id) {
            setLoading(true);
            getInstitutionByTypeId(id)
                .then(res => {
                    setSelectedInstitutionType(id);
                    setGroupedInstitutions(groupBy(res.data, 'city'));
                    setInstitutions(res.data);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                    message.error(dictionary?.SomethingWentWrong[language]);
                })
        }

    }

    const onSelectInstitution = value => {
        if (value) {
            'director' !== userRole() && setSelectedInstitution(institutions.filter(x => x.id == value)[0]);
            setLoading(true);
            setSelectedStudent();
            getInstitutionClasses(value)
                .then(({ data }) => {
                    setClasses(data)
                    const tempClass = []
                    data.map(items => {
                        tempClass.push({
                            className: `${items.year} ${items.letter}`,
                            idClass: items.id
                        })
                    })
                    getStudentsByInstitutionId(value)
                        .then(({ data }) => {
                            setStudents(data)
                            setLoading(false)
                            const temp = []
                            data.map(items => {
                                tempClass.forEach(el => {
                                    if (el.idClass === items.classId) {
                                        temp.push({
                                            ...items,
                                            ...el
                                        })
                                    }
                                });

                            })
                            setGroupedClasses(groupBy(temp, 'className'))
                        })
                        .catch(() => {
                            setLoading(false);
                            message.error(dictionary?.SomethingWentWrong[language], 4);
                        });
                })
                .catch(() => {
                    setLoading(false);
                    message.error(dictionary?.SomethingWentWrong[language], 4);
                });
        }
        else {
            setSelectedInstitution('')
        }

    };

    const onSelectStudent = value => {
        if (value) {
            setSelectedStudent(students.filter(x => x.id == value)[0]);
        }
    };

    const confirm = () => {
        deleteStudent(selectedStudent.id)
            .then(() => {
                message.success(dictionary?.OperationSuccessful[language]);
                setSelectedStudent(null);
                filterInstitutionsByTypeId(selectedInstitutionType);
                onSelectInstitution(selectedInstitution.id)
            })
            .catch(() => {
                setLoading(false);
                message.error(dictionary?.SomethingWentWrong[language]);
            })
    }

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setSelectedStudent({ ...selectedStudent, [name]: value });
    }

    const saveEditedStudent = () => {
        if (
            selectedStudent.firstName && selectedStudent.lastName &&
            selectedStudent.city && selectedStudent.country &&
            selectedStudent.classId && selectedStudent.id && selectedStudent.institutionId &&
            selectedStudent.langId && selectedStudent.phone && selectedStudent.phone &&
            selectedStudent.studyYear && selectedStudent.yearOfStudy &&
            selectedStudent.users.login && selectedStudent.users.email
        ) {
            setEdit(false);
            updateStudent(selectedStudent)
                .then(res => {
                    filterInstitutionsByTypeId(selectedInstitutionType);
                    onSelectInstitution(selectedInstitution.id)
                    message.success(dictionary?.SuccessfullyChanged[language]);
                })
                .catch(() => {
                    setLoading(false);
                    message.error(dictionary?.SomethingWentWrong[language]);
                })
        }
        else {
            message.error(dictionary?.FillTheAllRequiredFields[language]);
        }
    }


    const onChange = ({ name, value }) => {
        if (name === 'active') {
            setSelectedStudent({ ...selectedStudent, users: { ...selectedStudent.users, [name]: value ? 1 : 0 } });
        }
        else {
            setSelectedStudent({ ...selectedStudent, [name]: value });
        }
    }


    const rules = (value, name = '') => {
        if (name === 'login') {
            if (!selectedStudent.users.login.match(loginRegex)) {
                return { validateStatus: 'error', help: dictionary?.OnlyLatinAndNumber[language] };
            } else {
                return { validateStatus: 'success', help: null };
            }
        } else if (name === 'email') {
            if (!selectedStudent.users.email.match(emailRegex)) {
                return { validateStatus: 'error', help: dictionary?.InvalidEmail[language] };
            } else {
                return { validateStatus: 'success', help: null };
            }
        } else if (name === 'studyYear') {
            if (!selectedStudent.studyYear.match(schoolYearRegex)) {
                return { validateStatus: 'error', help: dictionary?.SchoolStudyYear[language] };
            } else {
                return { validateStatus: 'success', help: null };
            }
        } else if (name === 'phone') {
            if (!selectedStudent.phone.match(phoneRegex)) {
                return { validateStatus: 'error', help: dictionary?.InvalidPhone[language] };
            } else {
                return { validateStatus: 'success', help: null };
            }
        } else if (name === 'yearOfStudy') {
            const years = value.split('/');
            if (!selectedStudent.yearOfStudy.match(studyYearRegex)) {
                return { validateStatus: 'error', help: dictionary?.StudyYearField[language] };
            }
            if (years[0] > years[1]) {
                return {
                    validateStatus: 'error',
                    help: dictionary?.StudyYearFromLessThanTo[language],
                };
            }
            if (
                Number.isInteger(parseInt(years[0])) &&
                Number.isInteger(parseInt(years[1])) &&
                years[1] - years[0] !== 1
            ) {
                return {
                    validateStatus: 'error',
                    help: dictionary?.StudyYearValidate[language],
                };
            }
            else {
                return { validateStatus: 'success', help: null };
            }
        } else if (!value)
            return { validateStatus: 'error', help: dictionary?.RequiredField[language] }
        else return { validateStatus: 'success', help: null }
    }


    useEffect(() => {
        getInstitutionsType().then(({ data }) => setInstitutionsType(data));
        getLanguagesType().then(({ data }) => setLanguagesType(data));
        
        if ('director' === userRole()) {
            setLoading(true);
            getAuthorizedPersonsProfile()
                .then(({ data }) => {
                    filterInstitutionsByTypeId(data?.institution?.institutionTypeId);
                    setSelectedInstitution(data?.institution);
                    onSelectInstitution(data?.institution?.id);
                    setLoading(false);
                })
                .catch(() => {
                    message.error(dictionary?.SomethingWentWrong[language], { duration: 4 });
                    setLoading(false);
                });
        }
    }, []);

    return (
        <>
            <Row style={{ marginTop: '30px' }} gutter={16}>
                <Col span={8}>
                    <Select
                        placeholder={dictionary?.InstitutionType[language]}
                        size='large'
                        style={{ width: '100%' }}
                        allowClear={true}
                        disabled={'director' === userRole()}
                        value={selectedInstitutionType}
                        onChange={(value) => filterInstitutionsByTypeId(value)}
                    >
                        {
                            institutionsType &&
                            institutionsType.map((el) => {
                                return (
                                    <Select.Option value={el.id} key={el.id}>
                                        {el.name}
                                    </Select.Option>
                                );
                            })
                        }
                    </Select>
                </Col>
                <Col span={16}>
                    <TreeSelect
                        showSearch
                        style={{ width: '100%' }}
                        size='large'
                        disabled={'director' === userRole() || !selectedInstitutionType}
                        value={selectedInstitution && selectedInstitution.id || null}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={dictionary?.SelectInstitutionOrSearch[language]}
                        allowClear
                        treeDefaultExpandAll
                        onChange={onSelectInstitution}
                        filterTreeNode={(search, item) => {
                            return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
                        }}
                    >
                        {
                            groupedInstitutions && Object.keys(groupedInstitutions).map((key) => {
                                return (
                                    <TreeNode title={key} key={`city${key}`} disabled>
                                        {
                                            groupedInstitutions[key].map(value => {
                                                return (
                                                    <TreeNode key={value.id} value={value.id} title={value.name} />
                                                );
                                            })
                                        }
                                    </TreeNode>
                                );

                            })
                        }

                    </TreeSelect>
                </Col>
                <Col span={24} style={{ marginTop: '25px' }}>
                    <TreeSelect
                        showSearch
                        style={{ width: '100%' }}
                        size='large'
                        disabled={!selectedInstitution}
                        value={selectedStudent && `${selectedStudent.lastName} ${selectedStudent.firstName} ${selectedStudent.middleName}` || null}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={dictionary?.SelectClassOrSearch[language]}
                        allowClear
                        treeDefaultExpandAll
                        onChange={onSelectStudent}
                        filterTreeNode={(search, item) => {
                            return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
                        }}
                    >
                        {
                            groupedClasses && Object.keys(groupedClasses).map((key) => {
                                return (
                                    <TreeNode title={key} key={`className${key}`} disabled>
                                        {
                                            groupedClasses[key].map(value => {
                                                return (
                                                    <TreeNode key={value.id} value={value.id} title={`${value.lastName} ${value.firstName} ${value.middleName}`} />
                                                );
                                            })
                                        }
                                    </TreeNode>
                                );

                            })
                        }

                    </TreeSelect>
                </Col>
            </Row>
            {
                !selectedStudent &&
                <Empty style={{ marginTop: '100px' }} />
            }
            {
                selectedStudent &&
                <Card
                    style={{ marginTop: '30px' }}
                    actions={[
                        <Tooltip placement='top' title={dictionary?.Delete[language]}>
                            <Popconfirm
                                placement='bottom'
                                title={dictionary?.AreYouSureToDelete[language]}
                                onConfirm={confirm}
                                okText={dictionary?.Yes[language]}
                                cancelText={dictionary?.No[language]}
                            >
                                <DeleteTwoTone key='delete' twoToneColor='#eb2f96' />
                            </Popconfirm>
                        </Tooltip>,
                        <Tooltip placement='top' title={dictionary?.Edit[language]}>
                            {
                                !edit &&
                                <EditTwoTone key='edit' onClick={() => setEdit(true)} />
                            }
                            {
                                edit &&
                                <CarryOutTwoTone key='edit' onClick={saveEditedStudent} />
                            }
                        </Tooltip>,

                    ]}
                >
                    <Descriptions size='default' title={dictionary?.EditStudent[language]} bordered column={12}>
                        <Descriptions.Item label={dictionary?.FullName[language]} span={12}>
                            {
                                edit &&
                                <>
                                    <Form.Item hasFeedback  {...rules(selectedStudent.lastName, 'lastName')}>
                                        <Input style={{ width: '100%' }} size='middle' name='lastName' onChange={onInputChange}
                                            value={selectedStudent.lastName} placeholder={dictionary?.LastName[language]} maxLength={100} />
                                    </Form.Item>
                                    <Form.Item hasFeedback  {...rules(selectedStudent.firstName, 'firstName')}>
                                        <Input style={{ width: '100%' }} size='middle' name='firstName' onChange={onInputChange}
                                            value={selectedStudent.firstName} placeholder={dictionary?.FirstName[language]} maxLength={100} />
                                    </Form.Item>
                                    <Form.Item hasFeedback>
                                        <Input style={{ width: '100%' }} size='middle' name='middleName' onChange={onInputChange}
                                            value={selectedStudent.middleName} placeholder={dictionary?.MiddleName[language]} maxLength={100} />
                                    </Form.Item>
                                </>

                            }
                            {
                                !edit && `${selectedStudent.lastName} ${selectedStudent.firstName} ${selectedStudent.middleName}`
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.Institution[language]} span={12}>
                            {
                                edit &&
                                <Form.Item hasFeedback  {...rules(selectedInstitution.name, 'name')}>
                                    <Input style={{ width: '100%' }} size='middle' name='name' disabled
                                        value={selectedInstitution.name} placeholder={dictionary?.Institution[language]} />
                                </Form.Item>
                            }
                            {
                                !edit && selectedInstitution.name
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.UserLogin[language]} span={12}>
                            {
                                edit &&
                                <Form.Item hasFeedback  {...rules(selectedStudent.users.login, 'login')}>
                                    <Input style={{ width: '100%' }} size='middle' name='login' disabled
                                        value={selectedStudent.users.login} placeholder={dictionary?.UserLogin[language]} maxLength={100} />
                                </Form.Item>
                            }
                            {
                                !edit && selectedStudent.users.login
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.Email[language]} span={12}>
                            {
                                edit &&
                                <Form.Item hasFeedback  {...rules(selectedStudent.users.email, 'email')}>
                                    <Input style={{ width: '100%' }} size='middle' name='email' disabled
                                        value={selectedStudent.users.email && selectedStudent.users.email || ''} placeholder={dictionary?.Email[language]} maxLength={100} />
                                </Form.Item>
                            }
                            {
                                !edit && selectedStudent.users.email && selectedStudent.users.email
                            }
                        </Descriptions.Item>

                        <Descriptions.Item label={dictionary?.StudyYear[language]} span={12}>
                            {
                                edit &&
                                <Form.Item hasFeedback  {...rules(selectedStudent.studyYear, 'studyYear')}>
                                    <Input style={{ width: '100%' }} size='middle' name='studyYear'
                                        value={selectedStudent.studyYear} placeholder={dictionary?.StudyYear[language]} onChange={onInputChange} />
                                </Form.Item>
                            }
                            {
                                !edit && selectedStudent.studyYear
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.YearStudy[language]} span={6}>
                            {
                                edit &&
                                <Form.Item hasFeedback  {...rules(selectedStudent.yearOfStudy, 'yearOfStudy')}>
                                    <MaskedInput size='middle' style={{ width: '100%' }} name='yearOfStudy' value={selectedStudent.yearOfStudy} onChange={onInputChange} mask="11/11" placeholder="__/__" />
                                </Form.Item>
                            }
                            {
                                !edit && selectedStudent.yearOfStudy
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.Country[language]} span={6}>
                            {
                                edit &&
                                <Form.Item hasFeedback  {...rules(selectedStudent.country, 'country')}>
                                    <Input style={{ width: '100%' }} size='middle' name='country'
                                        value={selectedStudent.country} placeholder={dictionary?.Country[language]} onChange={onInputChange} />
                                </Form.Item>
                            }
                            {
                                !edit && selectedStudent.country
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.Phone[language]} span={6}>
                            {
                                edit &&
                                <Form.Item hasFeedback  {...rules(selectedStudent.phone, 'phone')}>
                                    <MaskedInput style={{ width: '100%' }} size='middle' name='phone' mask="+7 (111) 111-11-11"
                                        placeholder="+7 (___) ___-__-__" value={selectedStudent.phone} onChange={onInputChange} />
                                </Form.Item>
                            }
                            {
                                !edit && selectedStudent.phone
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.City[language]} span={6}>
                            {
                                edit &&
                                <Form.Item hasFeedback  {...rules(selectedStudent.city, 'city')}>
                                    <Input style={{ width: '100%' }} size='middle' name='city'
                                        value={selectedStudent.city} placeholder={dictionary?.City[language]} onChange={onInputChange} />
                                </Form.Item>
                            }
                            {
                                !edit && selectedStudent.city
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.Lang[language]} span={6}>
                            {
                                edit &&
                                <Form.Item hasFeedback  {...rules(selectedStudent.langId, 'langId')}>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder={dictionary?.Lang[language]}
                                        name='langId'
                                        onChange={(value) => onChange({ name: 'langId', value })}
                                        size='middle'
                                        value={selectedStudent.langId}
                                        allowClear={true}>
                                        {
                                            languagesType &&
                                            languagesType.map((el) => {
                                                return (
                                                    <Select.Option value={el.id} key={el.id}>
                                                        {el.name}
                                                    </Select.Option>
                                                );
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            }
                            {
                                !edit && selectedStudent.langId && languagesType.filter(el => el.id === selectedStudent.langId)[0].name
                            }

                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.Region[language]} span={6}>
                            {
                                edit &&
                                <Form.Item hasFeedback>
                                    <Input style={{ width: '100%' }} size='middle' name='region'
                                        value={selectedStudent.region} placeholder={dictionary?.Region[language]} onChange={onInputChange} />
                                </Form.Item>
                            }
                            {
                                !edit && selectedStudent.region
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.Class[language]} span={6}>
                            {
                                edit &&
                                <Form.Item hasFeedback  {...rules(selectedStudent.classId, 'classId')}>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder={dictionary?.Class[language]}
                                        size='middle'
                                        name='classId'
                                        onChange={(value) => onChange({ name: 'classId', value })}
                                        value={selectedStudent.classId}
                                        allowClear={true}>
                                        {
                                            classes &&
                                            classes.map((el) => {
                                                return (
                                                    <Select.Option value={el.id} key={el.id}>
                                                        {el.year} {el.letter}
                                                    </Select.Option>
                                                );
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            }
                            {
                                !edit && selectedStudent.classId && classes.filter(el => el.id === selectedStudent.classId)[0]?.year
                            }
                        </Descriptions.Item>
                        <Descriptions.Item label={dictionary?.IsActive[language]} span={6}>
                            <Switch disabled={!edit} checked={selectedStudent.users.active === 1}
                                name='active'
                                onChange={(value) => onChange({ name: 'active', value })}
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                            />
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            }
        </>
    );
};